import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {
	readChosenVersion,
	rememberManualVisit,
	scopeFromLaunch,
	TAKEOFFS_VERSIONS,
	TakeoffsVersion,
	versionSignInUrl,
	writeChosenVersion,
} from "../../utils/takeoffsVersion";
import "./chooseVersion.scss";

const LABELS = {
	classic: "chooseVersion.classic",
	new: "chooseVersion.new",
	ai: "chooseVersion.ai",
} as const;

/**
 * Premium's Utilities opens this before any version. Nothing signs in until a version is chosen.
 * The last choice is marked; the screen still waits.
 */
const ChooseVersionPage: React.FC = () => {
	const {t} = useTranslation(undefined, {useSuspense: false});
	const search = window.location.search;
	const scope = scopeFromLaunch(search);
	const [lastChoice] = useState(() => readChosenVersion(scope));
	const leaving = useRef(false);

	const choose = (version: TakeoffsVersion) => {
		if (leaving.current) return;
		leaving.current = true;
		writeChosenVersion(scope, version);
		rememberManualVisit(version);
		window.location.href = versionSignInUrl(version, search);
		setTimeout(() => {
			leaving.current = false;
		}, 0);
	};

	return (
		<main className="choose-version">
			<div className="choose-version__card">
				<h1>{t("chooseVersion.title")}</h1>
				<p className="choose-version__hint">{t("chooseVersion.hint")}</p>
				<div className="choose-version__options" role="group" aria-label={t("chooseVersion.legend")}>
					{TAKEOFFS_VERSIONS.map(version => (
						<button
							key={version}
							type="button"
							className="choose-version__option"
							aria-pressed={lastChoice === version}
							onClick={() => choose(version)}
						>
							{t(LABELS[version])}
						</button>
					))}
				</div>
			</div>
		</main>
	);
};

export default ChooseVersionPage;
